// extracted by mini-css-extract-plugin
export default {"content":"DeleteVehicle_content__uX-JT","buttons":"DeleteVehicle_buttons__F0HM4"};